import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./VtexItems.module.css";
import {
  fetchApiDataVtex,
  getBatchVtexLast,
} from "../../../../redux/actions/apiActions";

function VtexItems({ item }) {
  const dispatch = useDispatch();
  const batches = useSelector((s) => s.apiData.batchVtexSarkanyus);
  const [polling, setPolling] = useState(false);
  let itemStatusStyle = "";
  // polling effect
  useEffect(() => {
    if (!polling) return;
    const id = setInterval(() => {
      dispatch(getBatchVtexLast());
    }, 60000);
    return () => clearInterval(id);
  }, [polling, dispatch]);

  useEffect(() => {
    const last = batches[batches.length - 1];
    if (
      last &&
      ["Llamado", "Obteniendo", "Reestructurando", "Guardando"].includes(
        last.status
      )
    ) {
      setPolling(true);
    }
  }, [batches]);

  useEffect(() => {
    const last = batches[batches.length - 1];

    if (polling && last && ["Finalizado", "Error"].includes(last.status)) {
      setPolling(false);
    }
  }, [batches, polling]);

  const msToTime = (ms) => {
    if (typeof ms !== "number" || isNaN(ms)) {
      return "-";
    }
    const totalSeconds = Math.floor(ms / 1000);

    const seconds = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);

    // Aquí creamos un helper para rellenar con ceros a la izquierda
    const pad = (n) => String(n).padStart(2, "0");

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const formatIsoWithDate = (isoString) => {
    const d = new Date(isoString);
    if (isNaN(d.getTime())) {
      return "-";
    }
    const pad = (n) => String(n).padStart(2, "0");
    const hours = pad(d.getUTCHours());
    const minutes = pad(d.getUTCMinutes());
    const day = pad(d.getUTCDate());
    const month = pad(d.getUTCMonth() + 1);
    const year = d.getUTCFullYear();
    return `${hours}:${minutes} ${day}-${month}-${year}`;
  };

  const handleDispatch = () => {
    dispatch(fetchApiDataVtex());
    setTimeout(() => {
      dispatch(getBatchVtexLast());
    }, 10000);
    setPolling(true);
  };

  switch (item.status) {
    case "Llamado":
      itemStatusStyle = "llamado";
      break;
    case "Obteniendo":
      itemStatusStyle = "obteniendo";
      break;
    case "Reestructurando":
      itemStatusStyle = "reestructurando";
      break;
    case "Guardando":
      itemStatusStyle = "guardando";
      break;
    case "Finalizado":
      itemStatusStyle = "finalizado";
      break;
    case "Error":
      itemStatusStyle = "error";
      break;
    default:
      break;
  }
  return (
    <div className={style.shopifyItemsContainer}>
      <div className={style.ShopifyItemsEncabezado}>
        <ul className={`${style.uLlist} nav row`}>
          <li className="nav-item col">
            <span className="nav-link" href="#">
              {item?.itemsCounts}
            </span>
          </li>
          <li className="nav-item col">
            <span className="nav-link" href="#">
              {item ? formatIsoWithDate(item.initializedAt) : null}
            </span>
          </li>
          <li className="nav-item col">
            <span className="nav-link" href="#">
              {item ? formatIsoWithDate(item.finishedAt) : null}
            </span>
          </li>
          <li className="nav-item col">
            <span className="nav-link" href="#">
              {item
                ? msToTime(parseInt(item?.durationTime?.replace(/\D/g, ""), 10))
                : null}
            </span>
          </li>
          <li className="nav-item col">
            <div className={style.tooltipContainer}>
              <span className={`${style[itemStatusStyle]} nav-link`}>
                {item.status}
              </span>
              <div className={style.tooltipText}>{item.description}</div>
            </div>
          </li>
          <li className="nav-item col">
            <span className="nav-link" href="#">
              <button
                type="button"
                className={`${style.buttonCall} btn btn-light`}
                onClick={handleDispatch}
              >
                {" "}
                Llamar ahora{" "}
              </button>
            </span>
          </li>

          <li className="nav-item col">
            <a
              href={`${process.env.REACT_APP_API}/emarsys-items/all-sarkany-items`}
              download="export.csv"
              className={`${style.buttonCall} btn btn-light nav-link`}
            >
              Descargar CSV
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default VtexItems;
